export const LOCAL_STORAGE_KEYS = {
  ACCESS_TOKEN: "token",
  REFRESH_TOKEN: "refreshToken",
  ACCESS_TOKEN_EXP: "accessTokenExp",
  USER_ID: "user_id",
  USER_KEY: "user_key",
};
